/* eslint import/no-extraneous-dependencies: off */
import { createSlice } from '@reduxjs/toolkit';
import { getProfileInfo } from './asyncThunks';

const initialState = {
  id: undefined,
  name: undefined,
  email: undefined,
  phone: undefined,
  avatar: undefined,
  role: undefined,
  scopes: [],
  status: false,
  model: undefined,
  metadata: {},
  background: '#666',
  shortcuts: [],
  isLoading: true,
};

const profileSlice = createSlice({
  name: 'profile',
  initialState,
  reducers: {
    clearProfileInfo: (state) => initialState,
    setProfileInfo: (state, { payload }) => {
      return payload;
    },
    upsertProfileInfo: (state, { payload }) => {
      return { ...state, ...payload };
    },
  },
  extraReducers: {
    [getProfileInfo.pending]: (state) => {
      return { ...state, isLoading: true };
    },
    [getProfileInfo.fulfilled]: (state, { payload }) => {
      return {
        ...state,
        isLoading: false,
        errors: [],
        ...payload,
      };
    },
    [getProfileInfo.rejected]: (state, { payload }) => {
      return { ...state, isLoading: false, errors: payload };
    },
  },
});

export const { clearProfileInfo, setProfileInfo, updateShortcuts, setRole, upsertProfileInfo } =
  profileSlice.actions;

export const selectProfile = ({ profile }) => profile;

export const selectProfileShortcuts = ({ profile }) => profile.shortcuts;

export default profileSlice.reducer;
